/**
 * single-page/10000/List.js — AI 안전지수 보조 목록 컬럼 정의.
 *
 * maot_client 규약: { getHead, getCol(index, value, func), getSearchKeyValue, getSearchKeyword }.
 *  - func.getContent(value) → post_content(JSON).body 객체
 *  - func.getCreatedDate(value.created_at) → 작성일 포맷
 *  - getSearchKeyValue / getSearchKeyword 는 TableListPage 가 가드 없이 호출하므로 반드시 존재해야 한다.
 *    (없으면 목록 초기화 시 TypeError → loadList 중단 → 빈 목록 표시)
 * 안전지수는 단독 의미부여 금지(목록 표시용 수치) · 사고예측/확률 아님.
 */
export default {
  getHead: () => {
    return [
      { name: "제목", key: "body.title" },
      { name: "작성일", key: "body.stdInfo.date" },
      { name: "작성자", key: "body.stdInfo.writer_name" },
      { name: "AI 안전지수", key: "body.ai_safety_result.safety_index" },
      { name: "검토상태" },
      { name: "승인필요", key: "body.ai_safety_result.approval_required" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const content = func.getContent(value) || {};
      const std = content.stdInfo || {};
      const ai = content.ai_safety_result || {};
      const review = content.ai_review || {};
      switch (index) {
      case 0: // 제목
        return content.title || std.field_name || "";
      case 1: // 작성일
        return std.date || func.getCreatedDate(value.created_at);
      case 2: // 작성자
        return std.writer_name || (value.writer && value.writer.name) || "";
      case 3: // AI 안전지수 (단독 해석 금지 — 표시용)
        return ai.safety_index !== null && ai.safety_index !== undefined ? ai.safety_index : "-";
      case 4: { // 검토상태
        const decided = Object.keys(review).length;
        return decided > 0 ? `검토 ${decided}건` : "미검토";
      }
      case 5: // 승인필요
        return ai.approval_required ? "Y" : "N";
      }
    } catch (e) { /* ignore */ }
    return "";
  },
  // 표준 검색 인터페이스(별도 검색 폼 없음 — 빈 값 반환). TableListPage 가 무조건 호출하므로 필수.
  getSearchKeyValue: () => ({}),
  getSearchKeyword: () => [],
};
